import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import WebFont from 'webfontloader';

WebFont.load({
   google: {
     families: ['Be+Vietnam+Pro:600,400,700', 'sans-serif']
   }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);